import getHelper from "../helpers/getHelper";
import configs from "../helpers/configs";

const analyzeOrderChanges = (data, currentData) => {
  const added = data
    .filter(
      (newItem) =>
        !currentData.some((item) => item.order_id === newItem.order_id)
    )
    .map((item) => ({
      created_time: new Date().toLocaleString(),
      product_id: item.product_id,
      side: "BUY",
    }));
  const removed = currentData
    .filter(
      (item) => !data.some((newItem) => newItem.order_id === item.order_id)
    )
    .map((item) => ({
      created_time: new Date().toLocaleString(),
      product_id: item.product_id,
      side: "SELL",
    }));
  const combinedChanges = [...added, ...removed];
  // 🆕 Save full added/removed item list into localStorage
  const existingLog = JSON.parse(localStorage.getItem("orderChangeLog")) || [];
  const updatedLog = [...combinedChanges, ...existingLog].sort((a, b) => {
    return new Date(b.created_time) - new Date(a.created_time);
  });
  localStorage.setItem("orderChangeLog", JSON.stringify(updatedLog));
  return { combinedChanges, updatedLog };
};

const annotateDiffChanges = (newData, previousData) => {
  const oldDataMap = new Map(previousData.map((item) => [item.order_id, item]));

  return newData.map((order) => {
    const prev = oldDataMap.get(order.order_id);
    const prevDiff = prev ? parseFloat(prev.percentageDiff) : null;
    const newDiff = parseFloat(order.percentageDiff);
    let diffChange = "";
    if (prevDiff !== null) {
      if (newDiff < prevDiff) diffChange = "up";
      else if (newDiff > prevDiff) diffChange = "down";
    }

    return {
      ...order,
      diffChange,
    };
  });
};

export default async function getCurrentOrdersWithAnnotations(initDataRef) {
  const { baseUrl } = configs;
  try {
    const res = await getHelper(`${baseUrl}/currentopenorders`);

    // 🧠 Annotate diff changes (newData with diffChange field)
    const newData = annotateDiffChanges(res.data.data, initDataRef.current);

    // 🧠 Compare against existing for logs
    if (initDataRef.current.length !== 0) {
      await analyzeOrderChanges(newData, initDataRef.current);
    }
    const updateTime = new Date();
    return { newData, updateTime };
  } catch (err) {
    console.error("Fetch error:", err);
  }
}
